import React, { Fragment, useState } from "react";
import { Container, Accordion, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import "./showcase.css";

// ProfileCard now accepts props
function ProfileCard({ name, location, rate, rating, jobs, description, skills }) {
  return (
    <Card style={{ width: "18rem", margin: "1rem", borderRadius: "15px" }}>
      <Card.Body>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
          <img
            src="https://images.unsplash.com/photo-1640960543409-dbe56ccc30e2?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="profile"
            style={{
              width: 45,
              height: 45,
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: 12,
            }}
          />
          <div>
            <Card.Title style={{ marginBottom: 6, fontSize: 15 }}>{name}</Card.Title>
            <Card.Subtitle style={{ fontSize: 12, color: "#666" }}>
              {location}
            </Card.Subtitle>
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", fontSize: 14, marginBottom: "0.5rem" }}>
          <span>{location}</span>
          <span>⭐ {rating}</span>
          <span>🗂️ {jobs} jobs</span>
        </div>

        <Card.Text style={{ fontSize: 14, color: "#444" }}>
          {description}
        </Card.Text>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom: "1rem" }}>
          {skills.map((skill, i) => (
            <Badge key={i} bg="light" text="dark">{skill}</Badge>
          ))}
        </div>

        <Button variant="success" style={{ width: "100%" }}>
          See profile
        </Button>
      </Card.Body>
    </Card>
  );
}

function Showcase() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedLink, setSelectedLink] = useState("");

  const navItems = [
    {
      title: "Service Category",
      links: ["UI/UX Design", "Graphic Design", "Logo Design"],
    },
    {
      title: "Website Design",
      links: ["Landing Pages", "E-Commerce", "Portfolio Sites"],
    },
    {
      title: "Marketing",
      links: ["SEO", "Email Marketing", "Content Strategy"],
    },
  ];

  // Dummy profiles (you can replace with dynamic content later)
  const profiles = [
    {
      name: "Ahmad M.",
      location: "Cengkareng, Indonesia",
      location: "Indore, India",
      rating: "5.0",
      jobs: "78",
      description:
        "Senior full-stack developer with 13+ years of experience in PHP, Java, .NET.",
      skills: ["Java", "Custom PHP", ".NET Framework"],
    },
    {
      name: "Nina R.",
      location: "Delhi, India",
      location: "London, NY",
      rating: "4.9",
      jobs: "63",
      description:
        "Creative UI/UX designer with a passion for mobile-first designs.",
      skills: ["Figma", "Sketch", "Adobe XD"],
    },
    {
      name: "Liam K.",
      location: "Berlin, Germany",
      location: "Berlin",
      rating: "5.0",
      jobs: "92",
      description:
        "Experienced SEO expert & content strategist helping brands rank higher.",
      skills: ["SEO", "Google Analytics", "Content Marketing"],
    },
  ];

  return (
    <Fragment>
      <Container>
        <section>
          {selectedLink && (
            <div style={{ marginBottom: "10px" }}>
              <Button  onClick={() => setSelectedLink("")}>← Back </Button>
            </div>
          )}
          {/* NAV + ACCORDION only show if no link is clicked */}
          {!selectedLink && (
            <>
              <nav className="showcasenavbar">
                {navItems.map((item, index) => (
                  <ul key={index} className="showcasenav-links">
                    <li
                      className="showcasenav-item dropdown"
                      onMouseEnter={() => setActiveIndex(index)}
                      onMouseLeave={() => setActiveIndex(null)}
                    >
                      <a className="showcasenav-link">
                        {item.title}{" "}
                        {activeIndex === index ? (
                          <BsChevronUp style={{ marginLeft: 5 }} />
                        ) : (
                          <BsChevronDown style={{ marginLeft: 5 }} />
                        )}
                      </a>

                      {activeIndex === index && (
                        <div className="mega-menu">
                          <div className="mega-column">
                            <h6 style={{ marginBottom: 10 }}>{item.title}</h6>
                            <ul>
                              {item.links.map((link, i) => (
                                <li key={i}>
                                  <a

                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSelectedLink(link);
                                    }}
                                  >
                                    {link}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                    </li>
                  </ul>
                ))}
              </nav>
              <br />
              <Accordion defaultActiveKey="">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Service Category</Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col md={4}>
                        <h5>Design</h5>
                        <ul className="list-unstyled">
                          <li><a >UI/UX Design</a></li>
                          <li><a >Graphic Design</a></li>
                          <li><a >Logo Design</a></li>
                        </ul>
                      </Col>
                      <Col md={4}>
                        <h5>Development</h5>
                        <ul className="list-unstyled">
                          <li><a >Frontend Dev</a></li>
                          <li><a >Backend Dev</a></li>
                          <li><a >API Integration</a></li>
                        </ul>
                      </Col>
                      <Col md={4}>
                        <h5>Marketing</h5>
                        <ul className="list-unstyled">
                          <li><a >SEO</a></li>
                          <li><a >Content Marketing</a></li>
                          <li><a >Email Campaigns</a></li>
                        </ul>
                      </Col>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Website Design</Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col md={4}>
                        <h5>Landing Pages</h5>
                        <ul className="list-unstyled">
                          <li><a >Single Page</a></li>
                          <li><a >Multi Page</a></li>
                          <li><a >Product Page</a></li>
                        </ul>
                      </Col>
                      <Col md={4}>
                        <h5>E-commerce</h5>
                        <ul className="list-unstyled">
                          <li><a >Shopify</a></li>
                          <li><a >WooCommerce</a></li>
                          <li><a >Magento</a></li>
                        </ul>
                      </Col>
                      <Col md={4}>
                        <h5>Portfolio</h5>
                        <ul className="list-unstyled">
                          <li><a >Creative</a></li>
                          <li><a >Agency</a></li>
                          <li><a >Freelancer</a></li>
                        </ul>
                      </Col>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </>
          )}
          {/* Show profile cards when a link is selected */}
          {selectedLink && (
            <div style={{ marginTop: "20px" }}>
              <h5>Top Experts for: {selectedLink}</h5>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {profiles.map((profile, idx) => (
                  <ProfileCard key={idx} {...profile} />
                ))}
              </div>
            </div>
          )}
        </section>
      </Container>
    </Fragment>
  );
}

export default Showcase;
